import React, { Component } from 'react';
import v from 'voca';
import { makeInput, Loading } from "common-import/custom";
import { MobXHelper, Request, VarHelper } from "common-import/helpers";
import { inject, observer } from "mobx-react";
import { Link } from "react-router-dom";
import { isEmpty } from 'lodash';
import moment from 'moment';

const defaultImage = 'http://jimenezylievanoabogados.com/en/wp-content/themes/jimenezylievanoabogados/images/no_image_profile.jpg';

@inject("cartOrderStore", "userStore") @observer
class OrderDetail extends Component {

  constructor(props) {
    super(props);
    this.state = {
      order: {},
      status: '',
      creator: {},
      isLoading: true,
      isApproving: false,
      isDeleting: false,
    }
  }

  async componentDidMount() {
    await this.props.userStore.onReady();
    await this.getOrderDetail();
    this.getCreator();
    this.setState({isLoading: false});
  }

  getCreator = async () => {
    const { order } = this.state;
    const { userStore } = this.props;
    const res = await userStore.getUserDetailById(order.userId);
    if (!!res.error) return window.toast.error("Can not get USER info");
    this.setState({creator: res.data});
  };

  getOrderDetail = async () => {
    const { cartOrderStore, match } = this.props;
    const res = await cartOrderStore.orderDetail({id: match.params.id});
    if (!!res.error) return window.toast.error(JSON.stringify(res.error));
    this.setState({
      order: res.data,
      status: res.data.status
    });
  };

  deleteOrder = async (e) => {
    !!e && e.preventDefault();
    const { cartOrderStore, match } = this.props;
    const shouldDelete = confirm('Are you sure to delete order: ' + match.params.id);
    if (!shouldDelete) return;

    this.setState({isDeleting: true});
    const res = await cartOrderStore.deleteOrder(match.params.id);
    this.setState({isDeleting: false});
    if (!!res.error) return window.toast.error(JSON.stringify(res.error));
    window.toast.info("Deleted " + match.params.id + " successfully!");
    this.props.history.push("/orders/waiting");
  };

  renderDelete = () => {
    const {isDeleting} = this.state;
    return (
      <div style={{marginBottom: '16px'}}>
        <button onClick={e => this.deleteOrder(e)} disabled={isDeleting} className="btn btn-sm btn-danger">{isDeleting?'Deleting...':'Delete'}</button>
      </div>
    )
  };

  approveOrder = async e => {
    !!e && e.preventDefault();
    const { status } = this.state;
    const { cartOrderStore, match } = this.props;
    let continueApprove = confirm(`Are you sure want to approved this order with status: ${status}?`);
    if (continueApprove) {
      this.setState({isApproving: true});
      let result = await cartOrderStore.approve({ id: match.params.id, status });
      this.setState({isApproving: false});
      if (!!result.error) return window.toast.error(JSON.stringify(result.error));
      window.toast.info("Approved successfully!");
    }
  };

  renderApprove = () => {
    const { isApproving } = this.state;
    // if (status === undefined || status === "" || status === true || status === 1 || status === "COMPLETED") return null;
    return (
      <div style={{marginBottom: '24px'}} className="input-group">
        <select className="form-control" value={this.state.status} onChange={(e) => this.setState({ status: e.target.value })}>
          <option value="">Đơn này đang cần duyệt</option>
          {/* <option value="">Đơn này đang đang trong trạng thái: ({status})</option> */}
          <option value="WAITING">Chờ thanh toán (WAITING)</option>
          <option value="COMPLETED">Hoàn thành (COMPLETED)</option>
          <option value="SHIPPED_ORDERS">Đã Ship (SHIPPED_ORDERS)</option>
          <option value="ORDER_IN_PROCESS">Đang tiến hành (ORDER_IN_PROCESS)</option>
          <option value="FAIL_TO_CHARGE">Thanhh toán lỗi (FAIL_TO_CHARGE)</option>
          <option value="CANCELED_ORDERS">Hủy (CANCELED_ORDERS)</option>
        </select>
        <span className="input-group-append">
          <button disabled={isApproving} className="btn btn-primary" type="button" onClick={e => this.approveOrder(e)}>
            {isApproving ? 'Approving...':'Approve'}
          </button>
        </span>
      </div>
    )
  };

  renderBillShipInfo = () => {
    const { order } = this.state;
    const { shipInfo, billInfo } = order;

    if (isEmpty(shipInfo) || isEmpty(billInfo)) return null;

    return (
      <div className="row">
        <div className="col-md-6">
          <div className="block-content">
            <h4 className="block-content__title">Bill info</h4>
            <div className="block-content__body">
              <p><i className="fa fa-user mr-8"> </i> {billInfo.bill_name}</p>
              <p><i className="fa fa-envelope mr-8"> </i> {billInfo.bill_email}</p>
              <p><i className="fa fa-phone mr-8"> </i> {billInfo.bill_phone}</p>
              <p><i className="fa fa-map-marker mr-8"> </i> {billInfo.bill_address}</p>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="block-content">
            <h4 className="block-content__title">Ship info</h4>
            <div className="block-content__body">
              <p><i className="fa fa-user mr-8"> </i> {shipInfo.name}</p>
              <p><i className="fa fa-envelope mr-8"> </i> {shipInfo.email}</p>
              <p><i className="fa fa-phone mr-8"> </i> {shipInfo.phone}</p>
              <p><i className="fa fa-map-marker mr-8"> </i> {shipInfo.address}</p>
            </div>
          </div>
        </div>
      </div>
    )
  };

  renderCartDetail = () => {
    const {order, creator} = this.state;
    if (!order.cart || isEmpty(order.cart)) return null;

    return (
      <div className="block-content">
        {
          !creator || isEmpty(creator) ? '' :
            <div className="chip" style={{marginBottom: "24px"}}>
              <img src={creator.avatar || defaultImage} alt="" />
              <Link target="_blank" to={`/user/${creator.id}`}>{creator.name || "Anonymous"}</Link>
            </div>
        }
        <table className="table">
          <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">Name</th>
            <th scope="col">Price</th>
            <th scope="col">Amount</th>
            <th scope="col">Created at</th>
            <th scope="col">Updated at</th>
            <th scope="col">Total price</th>
          </tr>
          </thead>
          <tbody>
          {
            order.cart.slice().map((item, index) => {
              return (
                <tr key={"order-" + index}>
                  <th scope="row">{index + 1}</th>
                  <td>{item.product.name}</td>
                  <td>{VarHelper.textMoney(item.product.price)}</td>
                  <td>{item.amount}</td>
                  <td>{moment(item.createdAt).format("ll")}</td>
                  <td>{moment(item.updatedAt).format("ll")}</td>
                  <td>{VarHelper.textMoney(item.product.price * item.amount)}</td>
                </tr>
              )
            })
          }
          </tbody>
        </table>
      </div>
    )
  };

  render() {
    let { order, isLoading } = this.state;
    if (isLoading) return (<Loading> </Loading>);
    const total = (() => {
      if (order.cart == undefined) return 0;
      let value = 0;
      order.cart.slice().forEach((item) => {
        value = value + item.product.price * item.amount;
      });
      return value;
    })();
    return (
      <div className="animated fadeIn" id="order-detail-page">
        {this.renderDelete()}
        {this.renderApprove()}

        <div className="card">
          <div className="card-header">
            <div className="card-header-left">
            </div>
            <div className="card-header-right">
              <span className="mr-8">Total price</span>
              <span className="badge badge-success" style={{fontSize: '14px'}}>
                { VarHelper.moneyString(total)} VND
              </span>
            </div>
          </div>
          <div className="card-body">
            {this.renderCartDetail()}
            {this.renderBillShipInfo()}
          </div>
        </div>
      </div>
    );
  }
}

export default OrderDetail;



// WEBPACK FOOTER //
// ./src/views/Shop/OrderDetail.js